import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import Farms from "../../assets/img/farms.svg";
import FarmsProfile from "../../assets/img/farms-profile.svg";
import ProjectGrantees from "../../assets/img/project-grantees.svg";
import Producers from "../../assets/img/producers.svg";
import Fields from "../../assets/img/fields.svg";
import Partners from "../../assets/img/partners.svg";

const Dashboard: FC = () => {
  const roleid = localStorage.getItem("roleid");

  const UserName = localStorage.getItem("username");
  return (
    <div>
      <Header />
      <section className="midCon pt-5 pb-5">
        <div className="container">
          <div className="loginHd mb-4 mb-xl-5">
            <span className="d-block">Welcome {UserName}</span>
            Southern Piedmont, running through Virginia, North and South
            Carolina, Georgia, and Alabama
          </div>
          <ul className="dbLinks p-0 d-flex flex-wrap text-center">
            <li className="col-6 col-sm-2">
              <NavLink to="/farms">
                <span className="icon">
                  <img src={Farms} alt="Farms" />
                </span>{" "}
                Farms
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/farms-profile">
                <span className="icon">
                  <img src={FarmsProfile} alt="Farms Profile" />
                </span>{" "}
                Farm Profile
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/contacts">
                <span className="icon">
                  <img src={Producers} alt="Producers" />
                </span>{" "}
                Contacts
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <a href="/PoketProfile">
                <span className="icon">
                  <img src={Fields} alt="Fields" />
                </span>{" "}
                Poket Profile
              </a>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/soil">
                <span className="icon">
                  <img src={Producers} alt="Producers" />
                </span>{" "}
                Soil
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <a href="/Invoice">
                <span className="icon">
                  <img src={Fields} alt="Fields" />
                </span>{" "}
                Invoices
              </a>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/Summary">
                <span className="icon">
                  <img src={Partners} alt="Summary" />
                </span>{" "}
                F2F Summary
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/Management">
                <span className="icon">
                  <img src={Partners} alt="Management" />
                </span>{" "}
                F2F Management
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/Community">
                <span className="icon">
                  <img src={Partners} alt="Community" />
                </span>{" "}
                F2F Community
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/Accessibility">
                <span className="icon">
                  <img src={Partners} alt="Accessibility" />
                </span>{" "}
                F2F Accessibility
              </NavLink>
            </li>
            <li className="col-6 col-sm-2">
              <NavLink to="/Vendors">
                <span className="icon">
                  <img src={Partners} alt="Vendors" />
                </span>{" "}
                F2F Vendors
              </NavLink>
            </li>
          </ul>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Dashboard;
